import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from '../../_helper/config';
import { User } from '../../_models/user';
import { BaseService } from '../base.service';

export abstract class BaseAUTHService extends BaseService{

  constructor(url:string)
  {
    super("API", Config.info.apiServer.auth.url + "api/");
    this.url = url;
  }
}
